import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_105_products: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    screenId: "105",
    fabAction: {
      type: "add",
      screenId: "106",
      permissionKey: "Add",
    },
    title: "Products",
    style: {
      backgroundColor: "#F9FAFB",
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12,
          padding: 16,
          overflowY: "auto",
          maxHeight: "calc(100vh - 200px)",
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "part_no,item_name",
            Name: "product_summary",
            style: {
              maxHeight: "calc(100vh - 350px)",
            },
            SummeryActions: [
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/product_add/<id>",
                  Module: "product_add",
                },
                ActionType: "View",
                ScreenId: "106",
                tooltip: "View",
              },
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/product_add/<id>",
                  Module: "product_add",
                },
                ActionType: "Edit",
                permissionKey: "Edit",
                ScreenId: "106",
              },
              {
                Action: {
                  Action: "Delete",
                  Module: "product_summary",
                },
                ActionType: "Delete",
                permissionKey: "Delete",
                ScreenId: "105",
              },
            ],
            Form: {
              Name: "product_summary",
              TableName: "item_master",
              Query: "SELECT im.id, im.part_no, im.item_name, im.department_id, im.purchase_rate, im.sale_rate, im.rack_bin, COALESCE(u.username, NULLIF(TRIM(im.created_by::text), '')) AS created_by, im.created_at::date AS created_at FROM item_master im LEFT JOIN users u ON u.id::text = TRIM(im.created_by::text) WHERE im.soft_delete = 0 AND im.transaction_branch_id = '<branch_id>' ORDER BY im.created_at DESC",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
                {
                  IncludeLabel: true,
                  Label: "Part No.",
                  IsMandatory: true,
                  BindValue: "txt_parts",
                  Json_Attribute: "part_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Item name",
                  IsMandatory: true,
                  BindValue: "txt_itemname",
                  Json_Attribute: "item_name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Purchase Rate",
                  IsMandatory: true,
                  BindValue: "txt_purchaserate",
                  Json_Attribute: "purchase_rate",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Sale Rate",
                  IsMandatory: true,
                  BindValue: "txt_salerate",
                  Json_Attribute: "sale_rate",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Bin",
                  IsMandatory: true,
                  BindValue: "txt_rackbin",
                  Json_Attribute: "rack_bin",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Created by",
                  BindValue: "txt_created_by",
                  Json_Attribute: "created_by",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Created at",
                  BindValue: "txt_created_at",
                  Json_Attribute: "created_at",
                  componentType: ComponentType.DATETIME_FIELD,
                  showInSummary: true,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];
